import React, {Component, PropTypes} from 'react'
import {Time} from './time';

export class TableCard extends Component {

  static propTypes = {
    table: PropTypes.object.isRequired,
    memberProfiles: PropTypes.array
  }

  render () {
    const {table} = this.props;
    return (
      <div className='table card'>
        <div className='card__title'>
          {table.title}
        </div>
        <div className='card__caption'>
          <Time time={table._msgTime || table.created} format='time-since'/>
        </div>
        <div className='card__description'>
          With Connor McCutcheon, Devin Frenze, and Haley Thurston
        </div>
        <div className='card__extra'>
          <div className='icon-gear'/>
        </div>
      </div>
    );
  }
}
